import React from "react";
import { NavLink } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import "./css/footer.scss";

function Footer() {
  const handleGmailClick = (e) => {
    e.preventDefault();

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const desktopLink =
      "https://mail.google.com/mail/?view=cm&fs=1&to=madeinpolska5@gmail.com";

    const mobileLink = "mailto:madeinpolska5@gmail.com";

    const finalLink = isMobile ? mobileLink : desktopLink;

    window.open(finalLink, "_blank");
  };

  return (
    <div className="footer">
      <div className="footer__container">
        <NavLink
          to="https://www.instagram.com/madeinpolsce/profilecard/?igsh=MXJnOTA2YjM1dm84eQ=="
          target="_blank"
          className="instagram-icon"
        >
          <FaInstagram />
          <p>instagram</p>
        </NavLink>

        {/* Gmail кнопка с кастомной логикой */}
        <a href="/" onClick={handleGmailClick} className="gmail-icon">
          <SiGmail />
          <p>gmail</p>
        </a>
      </div>
    </div>
  );
}

export default Footer;
